module.exports = __webpack_public_path__ + "img/8.08e519a9.jpg";